import { useState } from "react";
import { FieldErrors } from "react-hook-form";
import BMView from "../../../components/View/BMView";
import CalendarPicker from "./CalendarPicker";
import HotelCitySearch from "./Search/HotelCitySearch";
import SearchFormCard from "./SearchFormCard";
import TravelerPicker from "./Traveler/TravelerPicker";
import {
  HotelSearchFormErrors,
  HotelSearchFormResource,
  HotelSearchFormValues,
} from "./types";

type Props = {
  locale: string;
  resource: HotelSearchFormResource;
  onSubmitForm: (values: HotelSearchFormValues) => void;
  onErrorForm: (errors: FieldErrors<HotelSearchFormValues>) => void;
  formErrors: HotelSearchFormErrors;
  previousSearchData?: Partial<HotelSearchFormValues>[];
  selectPreviousSearchData: (
    searchData: Partial<HotelSearchFormValues>
  ) => void;
};

/**
 *
 * To use this component, you will need to wrap this component with the following Components:
 * - `FormProvider` from `react-hook-form`
 * - `HotelAutocompleteProvider` from `submodule:ctv-web-core/src/providers/api/HotelAutocompleteContext`
 * - `TravelerPickerProvider` from `submodule:ctv-web-core/src/providers/api/TravelerPickerContext`
 * - `RecentlyViewedHotelsProvider` from `submodule:ctv-web-core/src/providers/api/RecentlyViewedHotelsContext`
 */
export default function HotelSearchForm(props: Props) {
  const {
    locale,
    resource,
    onSubmitForm,
    onErrorForm,
    formErrors,
    previousSearchData,
    selectPreviousSearchData,
  } = props;
  const [showSearch, setShowSearch] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [showTravelerPicker, setShowTravelerPicker] = useState(false);

  return (
    <BMView>
      <SearchFormCard
        onSearchFocus={() => setShowSearch(true)}
        onCalendarFocus={() => setShowCalendar(true)}
        onTravelerFocus={() => setShowTravelerPicker(true)}
        onSubmitForm={onSubmitForm}
        onErrorForm={onErrorForm}
        formErrors={formErrors}
      />
      <HotelCitySearch
        resource={resource}
        isVisible={showSearch}
        closeDialog={() => setShowSearch(false)}
        previousSearchData={previousSearchData}
        selectPreviousSearchData={selectPreviousSearchData}
      />
      <CalendarPicker
        locale={locale}
        isVisible={showCalendar}
        closeDialog={() => setShowCalendar(false)}
      />
      <TravelerPicker
        isVisible={showTravelerPicker}
        closeDialog={() => setShowTravelerPicker(false)}
      />
    </BMView>
  );
}
